export enum RulesMainViewMode {
  welcome = 'welcome',
  list = 'list',
  empty = 'empty'
}
